<template>
	<div id="patient-diaries-sheet" class="px-2">
		<h4 class="title is-size-5 has-text-left">Diario del paciente</h4>
		<div v-if="Object.keys(likertAndDiaries).length === 0">
			<article class="message is-dark">
				<div class="message-body">Aún no hay notas del paciente</div>
			</article>
		</div>
		<div class="note-list container" v-else>
			<div
				class="card"
				v-for="(diaryAndLikertJoint, date) in likertAndDiaries"
				:key="'likdiary-' + date"
			>
				<header class="card-header">
					<p class="card-header-title">
						{{ date }}
					</p>
					<a
						class="card-header-icon"
						aria-label="more options"
						@click="
							activeElement === date
								? (activeElement = '')
								: (activeElement = date)
						"
					>
						<span class="icon is-txt-primary">
							<i class="fas fa-book" aria-hidden="true"></i>
						</span>
					</a>
				</header>
				<div class="card-content" v-if="activeElement === date">
					<div class="content">
						<div
							class="block"
							v-if="diaryAndLikertJoint.likertRecords.length === 0"
						>
							<article class="message is-dark">
								<div class="message-body">
									No existe registros de escala Likert
								</div>
							</article>
						</div>
						<div class="block" v-else>
							<strong>Promedio Likert</strong>:
							{{ averageLikert(diaryAndLikertJoint.likertRecords) }}
						</div>
						<div v-if="diaryAndLikertJoint.diaryAnswers.length === 0">
							<article class="message is-dark">
								<div class="message-body">
									No existe registro en diario de las respuestas de paciente
								</div>
							</article>
						</div>
						<table class="table block" v-else>
							<thead>
								<tr>
									<th>Pregunta</th>
									<th>Respuesta</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(qa, i) in diaryAndLikertJoint.diaryAnswers"
									:key="'da-' + i"
								>
									<td>{{ qa.questionLabel }}</td>
									<td>{{ qa.answer || "(Sin respuesta)" }}</td>
								</tr>
							</tbody>
						</table>
						<br />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { Diaries, DiaryAnswer } from "@/domain/entities/DiaryQuestion";
	import { LikertRecord } from "@/domain/entities/Likert";
	import { now } from "@/domain/entities/EntityFields";
	import { computed, defineComponent, PropType, ref } from "vue";
import { DateTime } from "luxon";

	interface DiariesLikertJoint {
		diaryAnswers: DiaryAnswer[];
		likertRecords: LikertRecord[];
	}
	interface DiariesAndLikert {
		[diaryDate: string]: DiariesLikertJoint;
	}

	export default defineComponent({
		props: {
			createdAt: {
				type: Date,
			},
			diaries: {
				type: Object as PropType<Diaries>,
			},
			likertRecords: {
				type: Array as PropType<LikertRecord[]>,
				default: () => [],
			},
		},
		setup(props) {
			let createdAt = new Date(props.createdAt!);
			
			let today = now()// new Date();
			var difference = today.toMillis() - createdAt.getTime();
			var days = Math.ceil(difference / (1000 * 3600 * 24));

			let likertAndDiaries = computed(
				(): DiariesAndLikert => {
					let likertDiariesJoint: DiariesAndLikert = {};

					if (props.diaries !== undefined) {
						for (let i = 0; i < days; i++) {
							let key = today.minus({days: i}).toFormat('dd/MM/y');
							let likertRecords = props.likertRecords.filter(
								(lr) => DateTime.fromJSDate(new Date(lr.date)).toFormat('dd/MM/y') === key
							);

							likertDiariesJoint[key] = {
								diaryAnswers: props.diaries![key] || [],
								likertRecords: [...likertRecords],
							};
						}
					}

					return likertDiariesJoint;
				}
			);

			const activeElement = ref<string>("");

			function averageLikert(records: LikertRecord[]): string {
				return (records.reduce((acc: number, l) => l.score + acc, 0) / records.length).toFixed(2);
			}
			return {
				likertAndDiaries,
				activeElement,
				averageLikert,
			};
		},
	});
</script>
